import React from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="rounded-2xl bg-white p-4 text-left ring-1 ring-brand-100" data-id="element-56" data-mp="2l5ppm8bj0cdm">
      <div className="flex items-center justify-between gap-3" data-id="element-57" data-mp="2q3r92ucv6dpm">
        <p className="flex items-center gap-1.5 text-sm font-bold text-ink" data-id="element-58" data-mp="2q1wl176aq5hb">
          <FlameIcon className="h-4 w-4 shrink-0 text-urgent" aria-hidden="true" data-id="element-59" data-mp="2b5yq1s83z76o" />
          Only {SPOTS_LEFT} spots left at the promo price
        </p>
        <span className="shrink-0 text-sm font-extrabold text-urgent" data-id="element-60" data-mp="226bpt9r487f7">{filled}%</span>
      </div>
      <div className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-brand-50" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-61" data-mp="274ve3gt6lvaq">
        <div className="h-full rounded-full bg-urgent" style={{
        width: `${filled}%`
      }} data-id="element-62" data-mp="5d9zt9uav088" />
      </div>
      <p className="mt-2 text-xs text-ink-soft" data-id="element-63" data-mp="33l1zj2c8qmwo">When the spots run out, the price returns to $147 USD.</p>
    </div>;
}